import { normalizePathname } from "./matchPathname";

// class set on <body>: a global css rule hides the indigo container (#iaw-container)
export const INDIGO_HIDDEN_CLASS = "indigo-chatbot-hidden";

const INDIGO_HIDDEN_PATHS = new Set(["p/rete-assistenza"]);

// indigo is visible only on "it" pages, except support pages (salesforce chatbot) and INDIGO_HIDDEN_PATHS
export const isIndigoHidden = (pathname: string): boolean => {
  const [lang = "", ...segments] = normalizePathname(pathname)
    .split("/")
    .filter(Boolean);
  const path = segments.join("/");

  return (
    lang !== "it" || INDIGO_HIDDEN_PATHS.has(path) || path.includes("supporto")
  );
};
